import {FormattedMenuItem} from 'Util/Menu/Menu.type';

/** @namespace Steinkrueger/Util/DesktopMenu/getFirstLevelWithChild */
export const getFirstLevelWithChild = (menu: Record<string, FormattedMenuItem> = {}) => {
    if (Object.values(menu)[0]) {
        const { children } = Object.values(menu)[0];
        const childrenArray = Object.values(children);
        const defaultOpened = childrenArray.find((item) => Object.values(item.children).length);

        if (defaultOpened) {
            return [defaultOpened.item_id];
        }
    }

    return [];
};
